import {
  Control,
  Controller,
  FieldError,
  FieldValues,
  Path,
  UseFormRegisterReturn,
} from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react';

export const ValidatedInputField = ({
  label,
  registerProps,
  error,
  type = 'text',
}: {
  label: string;
  registerProps: UseFormRegisterReturn;
  error?: FieldError;
  type?: string;
}) => (
  <FormControl isInvalid={!!error}>
    <FormLabel>{label}</FormLabel>
    <Input
      size={'sm'}
      borderRadius={'md'}
      {...registerProps}
      type={type}
      _focus={error ? { borderColor: 'red.500', boxShadow: 'none' } : undefined}
    />
    <FormErrorMessage>{error?.message}</FormErrorMessage>
  </FormControl>
);

export const ReadOnlyInputField = ({
  label,
  value,
}: {
  label: string;
  value?: string | number | null;
}) => (
  <FormControl>
    <FormLabel>{label}</FormLabel>
    <Input
      size={'sm'}
      variant="filled"
      value={value ?? ''}
      isReadOnly
      borderRadius={'md'}
      _focus={{
        bg: 'gray.100',
        boxShadow: 'none',
        borderColor: 'transparent',
      }}
    />
  </FormControl>
);

export const ValidatedRadioField = <T extends FieldValues>({
  name,
  label,
  error,
  options,
  control,
}: {
  name: Path<T>;
  label: string;
  error?: FieldError;
  options: { value: string; label: string }[];
  control: Control<T>;
}) => (
  <FormControl isInvalid={!!error}>
    <FormLabel>{label}</FormLabel>

    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <RadioGroup {...field}>
          <Stack direction="row">
            {options.map((option) => (
              <Radio key={name + option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      )}
    />
    <FormErrorMessage>{error?.message}</FormErrorMessage>
  </FormControl>
);
